import { GetEvChargingSessionsResponse } from 'api/actions/get-ev-charging-sessions/get-ev-charging-sessions-response';

type Session = GetEvChargingSessionsResponse['sessions'][number];

/** Describes why a session's stored tariff is not a Phillip charge. */
export function getSessionBillingLabel(session: Session, _t: (message: string) => string): string | null {
  if (session.billingStatus === 'excluded') {
    return ['public', 'eroaming'].includes(session.billingExclusionReason || '')
      ? _t('Billed externally')
      : _t('Excluded from Phillip billing');
  }
  if (session.billingStatus === 'on-hold') return _t('Awaiting correction review');
  if (session.billingStatus === 'unassigned') return _t('Awaiting user assignment');
  return null;
}
